import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { isPresent } from '@app/shared/validators/extra-validators.module';
import dayjs, { ConfigType } from 'dayjs';

/**
 * Generate a validator function for validating that a user-filled date is strictly after a compared date. The function
 * accepts any Dayjs-compatible values for both the input and comparison dates. If the input date is invalid, an object
 * containing the key 'afterDate' will be returned, otherwise null is returned.
 * @param valueToCompare Date value to compare with input value.
 * @return Validator function.
 */
export const afterDate = (valueToCompare: ConfigType): ValidatorFn => {
  return (control: AbstractControl<ConfigType>): ValidationErrors | null => {
    // Transforming falsy values to null so that dates are invalid when original value is undefined
    const date = dayjs(control.value ?? null);
    const dateToCompare = dayjs(valueToCompare ?? null);
    if (!dateToCompare.isValid() || !date.isValid() || isPresent(Validators.required(control))) {
      return null;
    }
    return date.isAfter(dateToCompare) ? null : {afterDate: true};
  };
};
